export default class WarningOption {

	/**
	 *
	 * @param {String} value
	 * @param {String} label
	 * @param {String} color
	 * @param {String} level
	 * @param {String} type
	 */
	constructor(value, label, color, level, type) {

		/**
		 * @type {String}
		 */
		this.value = value;

		/**
		 * @type {String}
		 */
		this.label = label;

		/**
		 * @type {String}
		 */
		this.color = color;

		/**
		 * @type {String}
		 */
		this.level = level;

		/**
		 * @type {String}
		 */
		this.type = type;
	}
}
